import React, { useEffect, useState } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useNavigate } from 'react-router-dom';
import { KindePhoneInput } from './kinde-phone-input';
import {
  PREMATTER_ID_COOKIE,
  COLLECT_PHONE_NUMBER_COOKIE,
} from '../../constants';
import { actions } from '../../redux/slices';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import selectors from '../../redux/selectors';
const Redirect: React.FC<{ path: string }> = ({ path }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(path);
  }, [navigate, path]);
  return null;
};

export const AuthCallbackComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoading, isAuthenticated, user: kindeUser } = useKindeAuth();

  const prematterId = window.sessionStorage.getItem(PREMATTER_ID_COOKIE);

  const [collectPhoneNumber, setCollectPhoneNumber] = useState(
    window.sessionStorage.getItem(COLLECT_PHONE_NUMBER_COOKIE)
  );

  // The user is fetched earlier in the app
  const user = useAppSelector(selectors.user.getUser());

  useEffect(() => {
    dispatch(actions.session.fetch());
  }, [dispatch]);

  useEffect(() => {
    if (kindeUser?.email) {
      window.sessionStorage.setItem('lc_email', kindeUser.email);
    }
  }, [kindeUser?.email]);

  if (isLoading) {
    return null;
  }

  if (collectPhoneNumber && !user?.phone) {
    return <KindePhoneInput />;
  }

  if (prematterId) {
    return <Redirect path={`/case/${prematterId}`} />;
  }

  if (isAuthenticated) {
    return <Redirect path='/account' />;
  }

  return <Redirect path='/' />;
};
